import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.sass";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { store } from "store/store";
import { createTheme, ThemeProvider } from "@mui/material";
import { viVN } from "@mui/material/locale";
const theme = createTheme({}, viVN);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<>
		<Provider store={store}>
			<BrowserRouter>
				<ThemeProvider theme={theme}>
					<App />
				</ThemeProvider>
			</BrowserRouter>
			<ToastContainer></ToastContainer>
		</Provider>
	</>
);

reportWebVitals();
